interface MirrorLine {
  id: string;
  articleId: string | null;
  variantId: string | null;
  quantity: number;
  unitFactor?: number;
  sourceLineId?: string | null;
}

/** A partial delivery must never replace the original ordered quantities. */
export function canMirrorStorefrontDocumentLines(
  order: readonly MirrorLine[],
  delivery: readonly MirrorLine[],
): boolean {
  if (!order.length || order.length !== delivery.length) return false;
  return order.every((line, index) => {
    const child = delivery.find((candidate) => candidate.sourceLineId === line.id)
      ?? (delivery[index]?.sourceLineId ? undefined : delivery[index]);
    return child?.articleId === line.articleId
      && child.variantId === line.variantId
      && child.quantity === line.quantity
      && (child.unitFactor ?? 1) === (line.unitFactor ?? 1);
  });
}
